import React from 'react';
import './static/styles/App.css';
import './static/styles/fontawesome-5.12.0/css/all.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './static/styles/bootstrap-overrides.scss';
import 'bootstrap';

import { Router, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import PrivateOrLoginRoute from "./ui/routes/PrivateOrLoginRoute";
import PublicOrRedirectRoute from "./ui/routes/PublicOrRedirectRoute";
import ContextualRoute from "./ui/routes/ContextualRoute";
import AppOrErrorWrapper from "./ui/wrappers/AppOrErrorWrapper";
import AppRoutes from "./constants/AppRoutes";
import LoginContainer from "./ui/containers/LoginContainer";

//Initialize Action Singletons by importing them.
import AppNavigationActions from "./actions/AppNavigationActions"
import SessionActions from "./actions/SessionActions";
import MemberActions from "./actions/MemberActions";
import ProfileActions from "./actions/ProfileActions";
import SpaceActions from "./actions/SpaceActions";
import AsyncLibraryLoadActions from "./actions/AsyncLibraryLoadActions";
import AdvertisementActions from "./actions/AdvertisementActions";
import FileUploadActions from "./actions/FileUploadActions";
import SpaceReservationActions from "./actions/SpaceReservationActions";
import CheckoutActions from "./actions/CheckoutActions";

//Initialize Store Singletons by importing them
import SessionStore from "./stores/SessionStore";
import LoginViewStore from "./stores/LoginViewStore";
import ErrorStore from "./stores/ErrorStore";
import MemberStore from "./stores/MemberStore";
import ProfileStore from "./stores/ProfileStore";
import GoogleAPILibStore from "./stores/GoogleAPILibStore";
import SERPStore from "./stores/SERPStore";
import SearchFiltersStore from "./stores/SearchFiltersStore";
import PublicSpaceStore from "./stores/PublicSpaceStore";
import PrivateMySpacesStore from "./stores/PrivateMySpacesStore";
import SpaceCreateViewStore from "./stores/SpaceCreateViewStore";
import AdvertisementCreateViewStore from "./stores/AdvertisementCreateViewStore";
import PrivateMyAdvertisementsStore from "./stores/PrivateMyAdvertisementsStore";
import ImageUploaderStore from "./stores/ImageUploaderStore";
import SpaceEditViewStore from "./stores/SpaceEditViewStore";
import EmailVerificationViewStore from "./stores/EmailVerificationViewStore";
import PhoneNumberVerificationViewStore from "./stores/PhoneNumberVerificationViewStore";
import AdvertisementStore from "./stores/AdvertisementDetailsStore";
import MemberSpaceCalendarStore from "./stores/MemberSpaceCalendarStore";
import SpaceReservationStore from './stores/SpaceReservationStore';
import CheckoutViewStore from "./stores/CheckoutViewStore";
import SpaceBalanceStore from "./stores/SpaceBalanceStore";

import EventPublisher from "./utils/EventPublisher";
import ActionResultEvents from "./constants/events/ActionResultEvents";
import Logger from "./utils/Logger";

import {ENVIRONMENT_LEVEL} from "./constants/ConfigFromBuildEnvironment";
import PublicSpaceSERPContainer from "./ui/containers/PublicSpaceSERPContainer";
import PublicSpaceContainer from "./ui/containers/PublicSpaceContainer";
import MySpacesContainer from "./ui/containers/MySpacesContainer";
import SpaceCreateContainer from "./ui/containers/SpaceCreateContainer";
import AdvertisementCreateContainer from "./ui/containers/AdvertisementCreateContainer";
import MyAdvertisementsContainer from "./ui/containers/MyAdvertisementsContainer";
import SpaceEditContainer from "./ui/containers/SpaceEditContainer";
import SpaceManageCalendarContainer from "./ui/containers/SpaceManageCalendarContainer";
import PrivateSpaceSERPContainer from "./ui/containers/PrivateSpaceSERPContainer";
import SpaceDetailsContainer from "./ui/containers/SpaceDetailsContainer";
import AdvertisementEditContainer from "./ui/containers/AdvertisementEditContainer";
import SpaceReservationsContainer from "./ui/containers/SpaceReservationsContainer";
import AdvertisementDetailsContainer from "./ui/containers/AdvertisementDetailsContainer";
import AdvertisementOwnerProfileContainer from "./ui/containers/AdvertisementOwnerProfileContainer";
import CheckoutContainer from "./ui/containers/CheckoutContainer";
import AdvertisementReservationsContainer from "./ui/containers/AdvertisementReservationsContainer";
import SpaceOwnerProfileContainer from "./ui/containers/SpaceOwnerProfileContainer";
import ProfileEditContainer from "./ui/containers/ProfileEditContainer";
import AdvertisingBillingContainer from "./ui/containers/AdvertisingBillingContainer";
import SpaceBalanceContainer from "./ui/containers/SpaceBalanceContainer";

class NotFoundView extends React.Component {
    render() {
        return (<div>NOT FOUND</div>);
    }
}


const history = createBrowserHistory();
function App() {
    Logger.debug("STARTING FOR ENVIRONMENT: ", ENVIRONMENT_LEVEL);
    EventPublisher.publish(ActionResultEvents.HISTORY_READY, history);
    return (
        <Router history={history}>
            <div>
                <AppOrErrorWrapper>
                    <Switch>
                        <PublicOrRedirectRoute
                            exact path={AppRoutes.LOGIN}
                            component={LoginContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <ContextualRoute
                            exact path={AppRoutes.SEARCH_SPACES}
                            privateComponent={PrivateSpaceSERPContainer}
                            publicComponent={PublicSpaceSERPContainer}
                            usesDefaultFooter={false}/>
                        <ContextualRoute
                            exact path={AppRoutes.SPACE_DETAILS}
                            privateComponent={SpaceDetailsContainer}
                            publicComponent={PublicSpaceContainer}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.SPACE_EDIT}
                            component={SpaceEditContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.SPACE_MANAGE}
                            component={SpaceManageCalendarContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.SPACE_CREATE}
                            component={SpaceCreateContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.MY_SPACES}
                            component={MySpacesContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.SPACE_BALANCES}
                            component={SpaceBalanceContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.MY_ADVERTISEMENTS}
                            component={MyAdvertisementsContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.EDIT_ADVERTISEMENT}
                            component={AdvertisementEditContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.CREATE_ADVERTISEMENT}
                            component={AdvertisementCreateContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.ADVERTISEMENT_BILLING}
                            component={AdvertisingBillingContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.ADVERTISEMENT_DETAILS}
                            component={AdvertisementDetailsContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.ADVERTISEMENT_CONTACT_INFO}
                            component={AdvertisementOwnerProfileContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.SPACE_CONTACT_INFO}
                            component={SpaceOwnerProfileContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.EDIT_PROFILE}
                            component={ProfileEditContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.SPACE_RESERVATIONS}
                            component={SpaceReservationsContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.CHECKOUT}
                            component={CheckoutContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <PrivateOrLoginRoute
                            exact path={AppRoutes.ADVERTISEMENT_RESERVATIONS}
                            component={AdvertisementReservationsContainer}
                            redirectRoute={AppRoutes.SEARCH_SPACES}/>
                        <Route exact path={"/"}>
                                <Redirect to={AppRoutes.SEARCH_SPACES}/>
                        </Route>
                        <Route render={() => <NotFoundView/>}/>
                    </Switch>
                </AppOrErrorWrapper>
            </div>
        </Router>
    );
}

export default App;
